const fadeInAnimation = (index = 0, duration = 2000, delay = 1000) =>
  `fadeIn ${duration}ms ease-out ${delay * (index + 1)}ms forwards`;

export default fadeInAnimation;
